import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MalayalamKeyboard from "../components/MalayalamKeyboard";
import MalayalamGrid from "../components/MalayalamGrid";
import axios from "axios";
import { API_URL } from "../components/Constant";
import WordSuggestion from "../components/WordSuggestions";
import { Tab, Tabs, Typography } from "@mui/material";
import EnterAnswerAudio from "../components/EnterAnswerAudio";

function Malayalam() {
  const [questions, setQuestions] = useState([]);
  const [highlightedBox, setHighlightedBox] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  const initialGridData = [
    // Row 0
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "1", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
    // Row 1
    [
      { value: "", answer: "", visible: false },
      { value: "2", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "3", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
    ],
    // Row 2
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "4", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
    // Row 3
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
    // Row 4
    [
      { value: "5", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "6", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
    ],
    // Row 5
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "7", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
    // Row 6
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
    // Row 7
    [
      { value: "8", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "9", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 8
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
  ];

  const [allGridData, setAllGridData] = useState(initialGridData);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post(`${API_URL}/questions`, {
          language: "malayalam",
        });
        console.log(response.data);
        setQuestions(response.data);

        // Highlight the box corresponding to the first question on page load
        if (response.data.length > 0) {
          setHighlightedBox(response.data[0]); // Set the first question as highlighted
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQuestions();
  }, []);

  const handleCellClick = (question) => {
    setHighlightedBox(question);
    setCurrentQuestionIndex(question.question_number - 1);
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      setCurrentQuestionIndex(nextIndex);
      setHighlightedBox(questions[nextIndex]); // Highlight the next question
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      const prevIndex = currentQuestionIndex - 1;
      setCurrentQuestionIndex(prevIndex);
      setHighlightedBox(questions[prevIndex]); // Highlight the previous question
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue); // Update tab index
  };

  const handleQuestionClick = (question, index) => {
    handleCellClick({
      question_number: question.question_number,
      direction: question.direction,
      question_text: question.question_text,
      answer: question.answer,
      length: question.length,
    });
    setTabIndex(0); // Switch to the "Active Question" tab
    setCurrentQuestionIndex(question.question_number - 1); // Set the index of the selected question
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f1f3fc",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          gap: "12px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: "95%",
        }}
      >
        <h2>പദപ്രശ്നം</h2>
        {questions.length > 0 && (
          <MalayalamGrid
            highlightedBox={highlightedBox}
            onCellClick={handleCellClick}
            questions={questions}
            userAnswer={userAnswer}
            setHighlightedBox={setHighlightedBox}
            setUserAnswer={setUserAnswer}
            allGridData={allGridData}
            setAllGridData={setAllGridData}
          />
        )}

        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          centered
          sx={{
            ".MuiTabs-indicator": {
              display: "none", // Hide the default indicator
            },
            display: "flex",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <Tab
            label="Active Question"
            sx={{
              fontSize: "14px",
              color: "#5BC8AC",
              textDecoration: "none",
              textUnderlineOffset: "5px",
              "&:hover": {
                textDecoration: "underline", // Apply underline on hover
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
              "&.Mui-selected": {
                color: "#5BC8AC", // Keep the selected tab styled
                textDecoration: "underline", // Underline for the active tab
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px", // Make the underline bold for the active tab
              },
            }}
          />
          <Tab
            label="All Questions"
            sx={{
              fontSize: "14px",
              color: "#F18D9E",
              textDecoration: "none",
              textUnderlineOffset: "5px",
              "&:hover": {
                textDecoration: "underline", // Apply underline on hover
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px",
              },
              "&.Mui-selected": {
                color: "#F18D9E", // Keep the selected tab styled
                fontWeight: "bold",
                textDecoration: "underline", // Underline for the active tab
                textUnderlineOffset: "5px",
                textDecorationThickness: "1.5px", // Make the underline bold for the active tab
              },
            }}
          />
        </Tabs>

        {tabIndex === 0 && (
          <div>
            {highlightedBox ? (
              <Box
                sx={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h2 style={{ lineHeight: "0px" }}>
                  {highlightedBox.direction === "down"
                    ? "താഴോട്ട്"
                    : "വലത്തോട്ട്"}
                </h2>
                <p>
                  {highlightedBox.question_number}.{" "}
                  {highlightedBox.question_text}
                </p>
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <Button
                    sx={{
                      background: "none",
                      color: "#5BC8AC",
                      fontSize: "14px",
                      textDecoration: "none",
                      textUnderlineOffset: "5px",
                      "&:hover": {
                        background: "none",
                        color: "#5BC8AC",
                        fontSize: "14px",
                        textDecoration: "underline", // Apply underline on hover
                        textUnderlineOffset: "5px",
                        textDecorationThickness: "1.5px",
                      },
                    }}
                    variant="text"
                    onClick={handlePrevious}
                    disabled={currentQuestionIndex === 0} // Disable if it's the first question
                  >
                    Previous
                  </Button>

                  <Button
                    sx={{
                      background: "none",
                      color: "#F18D9E",
                      fontSize: "14px",
                      textDecoration: "none",
                      textUnderlineOffset: "5px",
                      "&:hover": {
                        background: "none",
                        color: "#F18D9E",
                        fontSize: "14px",
                        textDecoration: "underline", // Apply underline on hover
                        textUnderlineOffset: "5px",
                        textDecorationThickness: "1.5px",
                      },
                    }}
                    variant="text"
                    color="primary"
                    onClick={handleNext}
                    disabled={currentQuestionIndex === questions.length - 1} // Disable if it's the last question
                  >
                    Next
                  </Button>
                </Box>

                {/* <WordSuggestion
                  highlightedBox={highlightedBox}
                  allQuestions={questions}
                  setHighlightedBox={setHighlightedBox}
                  setUserAnswer={setUserAnswer}
                  allGridData ={allGridData}
                  setAllGridData={setAllGridData}
                /> */}

                <EnterAnswerAudio
                  highlightedBox={highlightedBox}
                  allQuestions={questions}
                  setHighlightedBox={setHighlightedBox}
                  setUserAnswer={setUserAnswer}
                  allGridData={allGridData}
                  setAllGridData={setAllGridData}
                />
              </Box>
            ) : (
              <p>ക്ഷമയോടെ കാത്തിരിക്കുക...</p>
            )}
          </div>
        )}

        {tabIndex === 1 && (
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              flexDirection: "column",
              marginBottom: "64px",
            }}
          >
            <h3>Question List</h3>
            {questions.map((q, index) => (
              <div
                key={index}
                onClick={() => handleQuestionClick(q, index)} // Make each question clickable
                style={{
                  cursor: "pointer",
                  marginBottom: "8px",
                  transition: "color 0.3s ease", // Smooth transition for the color change
                }}
                onMouseEnter={(e) => (e.target.style.color = "#32618D")} // Change color on hover
                onMouseLeave={(e) => (e.target.style.color = "initial")} // Reset color when hover ends
              >
                <Typography sx={{ fontSize: "14px", fontFamily: "Roboto" }}>
                  {q.question_number}. {q.question_text}
                </Typography>
              </div>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default Malayalam;
